export const root = "r1tyzecn";
export const title = "t1rg7dto";
export const alternate = "a1aolyj7";
export const altNumber = "ab5io4b";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.tsx");